// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"71efa070a60a802ace07","303":"c5614429e21e5158917f","495":"5ab8287ae23163c6d264"}[chunkId] + ".js";
};